module.exports = __webpack_public_path__ + "static/media/ML.2bc73fd8.png";